module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLight.32b2df73.woff";